import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 mb-10" }
const _hoisted_2 = { class: "w-1/6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Clear Filters  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.paramsCatalog.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsCatalog.search) = $event)),
        placeholder: "Search",
        clearable: ""
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_select, {
      placeholder: "Category",
      modelValue: _ctx.paramsCatalog.categories,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paramsCatalog.categories) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item._id,
            label: item.title,
            value: item._id,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Status",
      modelValue: _ctx.paramsCatalog.status,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paramsCatalog.status) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.name,
            value: item.value,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Partner",
      modelValue: _ctx.paramsCatalog.partners,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paramsCatalog.partners) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnersList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item._id,
            label: item.name,
            value: item._id,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Location",
      modelValue: _ctx.paramsCatalog.locations,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paramsCatalog.locations) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item._id,
            label: item.name,
            value: item._id,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Techniques",
      modelValue: _ctx.paramsCatalog.techniques,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paramsCatalog.techniques) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techniquesList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item._id,
            label: item.name,
            value: item._id,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Print areas",
      modelValue: _ctx.paramsCatalog.printAreas,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paramsCatalog.printAreas) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printAreasList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item._id,
            label: item.name,
            value: item._id,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      placeholder: "Type",
      modelValue: _ctx.paramsCatalog.type,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.paramsCatalog.type) = $event)),
      clearable: "",
      filterable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.name,
            value: item.value,
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      class: "ml-2",
      onClick: _ctx.clearFilters,
      title: "Refresh",
      size: "large",
      type: "info"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_CloseBold)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}